import { Version } from '@fuse/version/version';

const __FUSE_VERSION__ = '12.2.0';
export const FUSE_VERSION = new Version(__FUSE_VERSION__).full;
